"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Comma = exports.NumberCard = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _typography = require("../../typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "incremental-counterstyles__Wrapper",
  componentId: "sc-1wndi0i-0"
})(["display:", ";flex-direction:row;padding-top:28px;padding-bottom:21px;@media ", "{display:flex;}"], function (props) {
  return props.hideOnMobile ? 'none' : 'flex';
}, function (props) {
  return props.theme.queries.desktopAndUp;
});
exports.Wrapper = Wrapper;
var NumberCard = (0, _styledComponents["default"])('div').withConfig({
  displayName: "incremental-counterstyles__NumberCard",
  componentId: "sc-1wndi0i-1"
})(["background-color:", ";padding:2px;border-radius:8px;line-height:0;width:", "rem;;max-height:", "rem;min-height:", "rem;display:flex;flex-direction:column;align-items:center;justify-content:center;clip-path:inset(0 0 0 0);@media ", "{width:", "rem;}&:not(:first-of-type){margin-left:8px;}"], function (props) {
  return props.theme.colors.white;
}, 38 / 16, 90 / 16, 64 / 16, function (props) {
  return props.theme.queries.desktopAndUp;
}, 55 / 16);
exports.NumberCard = NumberCard;
var Comma = (0, _styledComponents["default"])(_typography.Title).withConfig({
  displayName: "incremental-counterstyles__Comma",
  componentId: "sc-1wndi0i-2"
})(["line-height:1;margin-right:-8px;"]);
exports.Comma = Comma;